var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskGauge4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 70,
    viewBox: "0 0 138 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_38630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383209 64.0531 1.54437 57.4861C3.99124 43.6478 10.628 30.782 20.7004 20.7096C33.6404 7.76962 51.1908 0.500002 69.4907 0.5C87.7906 0.499998 105.341 7.76962 118.281 20.7096C128.353 30.782 134.99 43.6478 137.437 57.4861C138.598 64.0531 133.085 69.5 126.416 69.5C119.747 69.5 114.499 63.9986 112.725 57.57C110.679 50.1544 106.74 43.3214 101.204 37.7863C92.7934 29.3753 81.3857 24.65 69.4907 24.65C57.5958 24.65 46.188 29.3753 37.777 37.7863C32.2418 43.3214 28.3029 50.1544 26.2564 57.57C24.4823 63.9986 19.2346 69.5 12.5657 69.5Z",
    fill: "#D5D6D8",
    style: {
      fill: "#D5D6D8",
      fill: "color(display-p3 0.8353 0.8392 0.8471)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383401 64.0533 1.54457 57.4863C3.35872 47.2264 7.48306 37.4564 13.6686 28.9428C22.2334 17.1543 34.3104 8.37989 48.1686 3.8771C62.0268 -0.625703 76.9547 -0.625698 90.8129 3.87711C100.821 7.12902 109.901 12.6089 117.399 19.843C122.198 24.4733 120.939 32.1205 115.544 36.0403C110.149 39.9602 102.67 38.5942 97.4558 34.4361C93.2727 31.0999 88.5007 28.5186 83.3502 26.8451C74.3423 23.9183 64.6392 23.9183 55.6313 26.8451C46.6235 29.7719 38.7735 35.4753 33.2063 43.1378C30.0231 47.5191 27.6797 52.4123 26.2565 57.5701C24.4825 63.9987 19.2346 69.5 12.5657 69.5Z",
    fill: "#28245C",
    style: {
      fill: "#28245C",
      fill: "color(display-p3 0.1569 0.1412 0.3608)",
      fillOpacity: 1
    },
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5657 69.5C5.89688 69.5 0.383401 64.0533 1.54457 57.4863C3.35872 47.2264 7.48306 37.4564 13.6686 28.9428C22.2334 17.1543 34.3104 8.37989 48.1686 3.8771C62.0268 -0.625703 76.9547 -0.625698 90.8129 3.87711C100.821 7.12902 109.901 12.6089 117.399 19.843C122.198 24.4733 120.939 32.1205 115.544 36.0403C110.149 39.9602 102.67 38.5942 97.4558 34.4361C93.2727 31.0999 88.5007 28.5186 83.3502 26.8451C74.3423 23.9183 64.6392 23.9183 55.6313 26.8451C46.6235 29.7719 38.7735 35.4753 33.2063 43.1378C30.0231 47.5191 27.6797 52.4123 26.2565 57.5701C24.4825 63.9987 19.2346 69.5 12.5657 69.5Z",
    fill: "url(#grad4)",
    style: {},
    shapeRendering: "optimizeSpeed"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 26,
    r: 7,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad4",
    x1: "0%",
    y1: "40%",
    x2: "50%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFB69E"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_38630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 69,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskGauge4);
export default __webpack_public_path__ + "static/media/risk-gauge-4.cf4b3a136d318de3d982638e410c8fc8.svg";
export { ForwardRef as ReactComponent };